import { DevControllerApiFactory } from 'api';
import { BASE_PATH } from 'features/service/config';

export const getBackendVersion = () =>
  DevControllerApiFactory(undefined, BASE_PATH)
    .version()
    .then(res => res.data);
